import { CompleteDataGeneralComponent } from './../admin/users/complete-data-general/complete-data-general.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';;
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../services/general.service';
import { ProvidersService } from '../services/providers.service';
import * as decode from 'jwt-decode';
import { TranslateService } from 'ng2-translate';
import { ModalComunicadosShowComponent } from 'app/admin/comunicados-show/comunicados-show';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  userToken: any;
  userId: any;
  profileId: any;
  providerId: any;
  messages: any;
  tokenInfo;
  tokenCrypt;
  firstSession:string;
  Notices: any[] = [];

  constructor(private toastr: ToastrService,
    private gralService: GeneralService,
    private provService: ProvidersService,
    private dialog: MatDialog,
    public translate: TranslateService
  ){
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);

    const idioma = localStorage.getItem('language');
    translate.use(idioma);

    gralService.changeTextHead('HOME');

    //console.log('idioma default', idioma);
    //localStorage.setItem('firstSession', 'yes');

    this.tokenInfo = tokenPayload;
    this.tokenCrypt = d[1];

    this.userId = tokenPayload.Id;
    this.profileId = tokenPayload.IdPerfil;
    this.providerId = tokenPayload.IdProveedor;
    if(this.profileId == 3){
      //this.getMessages();
    }
  }

  ngOnInit() {
    this.listNotice();
  }

  listNotice(){
    this.gralService.getNotice('123').then((res:any) => {
      if(res.TotalEntidades > 0){
        this.Notices = res.Entidades;
        if( this.Notices.length == 1)
        {
          this.show( this.Notices[0].IdComunicado  );
        }
      }
    })
  }

  show( id:string ){
    this.dialog.open(ModalComunicadosShowComponent, {
      // disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { id: id }
    });

    /*.afterClosed().subscribe(res=>{

    });*/
  }


  getMessages(){
    this.provService.getMessages(this.providerId, this.userId, this.userToken).then((data) => {

      if(data['EsValido']){
        for(let g = 0; g < data['Entidad'].Mensaje.length; g++){
          if(data['Entidad'].Mensaje[g].Key == 'ERROR'){
            this.toastr.error(data['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
          }
          if(data['Entidad'].Mensaje[g].Key == 'WARNING'){
            this.toastr.warning(data['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
          }
          if(data['Entidad'].Mensaje[g].Key == 'OK'){
            this.toastr.success(data['Entidad'].Mensaje[g].Value, '', {disableTimeOut: true, closeButton: true});
          }
        }
      }
    }, (err) => {
      console.log(err);
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  complementInfo(info){
    console.warn('abre modal')
    this.dialog.open(CompleteDataGeneralComponent, {
      disableClose:true,
      hasBackdrop: true,
      minWidth: '80%',
      // position: {
      //   top: '6%'
      // },
      data: { tempRegister: info }
    });
  }


}
